(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-home-promo"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-tc-daily-promo]');
    sections.forEach((section) => {
      const output = section.querySelector('[data-tc-promo-countdown]');
      if (!output) return;
      const update = () => {
        const now = new Date();
        const next = new Date(now);
        next.setHours(24, 0, 0, 0);
        const diff = Math.max(0, next.getTime() - now.getTime());
        const totalSeconds = Math.floor(diff / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        output.textContent = [hours, minutes, seconds].map((value) => String(value).padStart(2, '0')).join(':');
      };
      update();
      window.setInterval(update, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
